import React, { createContext, useContext, useState } from "react";
import { useSelector } from "react-redux";
import { DEFAULT_PHONE } from "@constants/appDefaults";

const OrderContext = createContext();

export const OrderProvider = ({ children }) => {
  const company_id = useSelector((state) => state.user.companyId);
  const user_id = useSelector((state) => state.user.user);
  const [popupShow, setPopupShow] = useState("");
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [serviceCompanies, setServiceCompanys] = useState([]);
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [editService, setEditService] = useState({
    _id: "",
    start_date: "",
    end_date: "",
    location: "",
    destination: "",
    amount: "",
    service_type_id: "",
    service_company_id: "",
    account_code: "",
    company_id: company_id,
    operator_id: user_id,
    customFields: {},  // Dynamic custom fields
  });
  const [addService, setAddService] = useState({
    _id: "",
    start_date: "",
    end_date: "",
    location: "",
    destination: "",
    amount: "",
    service_type_id: "",
    service_company_id: null,
    account_code: "",
    company_id: company_id,
    operator_id: user_id,
    customFields: {},  // Dynamic custom fields
  });

  const [popUpData, setPopUpData] = useState({
    _id: "",
    operator_id: user_id,
    full_name: "",
    phone_number: DEFAULT_PHONE,
    national_ID_number: "",
    payment_method: "",

    // Consistent date fields
    start_date: "",
    end_date: "",

    // Location and Destination for different services
    location: "",
    destination: "",

    detales: "",
    note: "",
    total_price: 0,
    discount: "",
    passenger: "",
    services: [],
    passengers: [],

    // Dynamic custom fields
    customFields: {},
  });
  const [customerData, setCustomerData] = useState({
    full_name: "",
    gender: "",
    national_ID_number: "",
    email_address: "",
    phone_number: DEFAULT_PHONE,
    channel: "",
    connection_dates: "",
    template_tour: "",
    note: "",
    allocator_id: user_id,
    operator_id: user_id,
    company_id: company_id,
    _id: "",
  });

  const value = {
    popupShow,
    setPopupShow,
    editService,
    setEditService,
    addService,
    setAddService,
    popUpData,
    setPopUpData,
    selectedOrder,
    setSelectedOrder,
    serviceCompanies,
    setServiceCompanys,
    filteredCompanies,
    setFilteredCompanies,
    customerData,
    setCustomerData,
  };

  return (
    <OrderContext.Provider value={value}>{children}</OrderContext.Provider>
  );
};

export const useOrderContext = () => {
  return useContext(OrderContext);
};
